const topics = [
  { label: '顶流塌房', heat: '99万+', color: 'bg-primary-100 text-primary-700' },
  { label: '综艺黑幕', heat: '87万+', color: 'bg-accent-100 text-accent-700' },
  { label: '网红翻车', heat: '76万+', color: 'bg-secondary-100 text-secondary-700' },
  { label: 'CP营业', heat: '65万+', color: 'bg-primary-100 text-primary-700' },
  { label: '恋情曝光', heat: '58万+', color: 'bg-accent-100 text-accent-700' },
  { label: '带货争议', heat: '52万+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '选角风波', heat: '47万+', color: 'bg-primary-100 text-primary-700' },
  { label: '剧本争议', heat: '43万+', color: 'bg-accent-100 text-accent-700' },
  { label: '演技吐槽', heat: '38万+', color: 'bg-secondary-100 text-secondary-700' },
  { label: '综艺新瓜', heat: '35万+', color: 'bg-primary-100 text-primary-700' },
  { label: '明星穿搭', heat: '31万+', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            大家都在讨论的热门标签，点击发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer ${item.color} hover:scale-105`}
            >
              <span>{item.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}